import { ActionCard } from '@graphcommerce/next-ui'
import { FieldValues } from '@graphcommerce/react-hook-form'
import { Trans } from '@lingui/react'
import { Box, Link } from '@mui/material'

export function AddressSummary(props: {
  address: FieldValues
  setAutocompleteSuccess: (success: boolean) => void
}) {
  const { address, setAutocompleteSuccess } = props
  const { street, houseNumber, city, postcode } = address
  return (
    <ActionCard
      layout='grid'
      value=''
      title={`${street} ${houseNumber}`}
      sx={(theme) => ({ mt: theme.spacings.xs })}
      details={
        <Box>
          <div>{city}</div>
          <div>{postcode}</div>
          <Link
            href='#'
            sx={{ mt: 1, display: 'inline-block' }}
            onClick={(e) => {
              e.preventDefault()
              return setAutocompleteSuccess(false)
            }}
          >
            <Trans id='Edit' />
          </Link>
        </Box>
      }
    />
  )
}
